module.exports = __webpack_public_path__ + "static/media/boy_dance_01.0497519e.gif";